// React libraries
import * as React from 'react';
// Custom Styles
import { useStyles } from "./BlueButtonStyles";
// Material-UI Core
import Button from '@mui/material/Button';
export const BlueButton = (props) => {
    const classes = useStyles(props);
    const { onClick, disabled, selected, type } = props;
    return (React.createElement(Button, { className: classes.blueButton, disabled: disabled, onClick: onClick }, props.children));
};
BlueButton.defaultProps = {
    onClick: () => { },
};
export default React.memo(BlueButton);
